import {useState} from 'react';
import {I18n} from '@aws-amplify/core';
import {FlexiAddButton} from '@flexinet/ui-components';

import {AddFormDrawer} from '../drawers/AddFormDrawer';

// Drawer open state is local to the button. The drawer is mounted only while
// open, so every open starts from a blank form.
export const AddRecordButton = () => {
    const [opened, setOpened] = useState(false);

    return (
        <>
            <FlexiAddButton onClick={() => setOpened(true)}>
                {I18n.get('New product')}
            </FlexiAddButton>
            {opened && <AddFormDrawer opened={opened} onClose={() => setOpened(false)}/>}
        </>
    );
};
